export default "__VITE_ASSET__Cjx3n9IO__"